import { RaiseText } from "../raise-components"
import React, { useState } from "react"

import { Button, Col, Form, Row, Space } from "@atos6/ui"
import { Card, FormContent } from "../App.styles"
import { useStore } from "../containers"
import {
  FormItemDocumentStateful,
  FormItemNameStateful,
  InputAccountDigitStateful,
  InputAccountNumberStateful,
  InputAgencyStateful,
  InputBankStateful,
  RadioCheckingSavingsStateful,
  RadioCpfCnpjStateful,
} from "../stateful"

export function FormAccountCell() {
  const {
    isAccountCreated,
    active,
    isSaveButtonDisabled,
    createAccount,
  } = useStore()

  const [isLoading, setIsLoading] = useState(false)

  async function submit() {
    setIsLoading(true)
    try {
      await createAccount()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Card disabled={isAccountCreated || !active}>
      <RaiseText
        fontSize="20px"
        fontWeight="600"
        textAlign="center"
        marginBottom="30px">
        Configuração de Conta Bancária para recebimento
      </RaiseText>

      <RaiseText fontSize="14px" textAlign="center" marginBottom="24px">
        Atenção: A conta precisa ser da mesma titularidade da organização
      </RaiseText>

      <Form layout="vertical">
        <FormContent>
          <Form.Item>
            <RadioCpfCnpjStateful />
          </Form.Item>

          <FormItemDocumentStateful />

          <FormItemNameStateful />

          <Form.Item>
            <RadioCheckingSavingsStateful />
          </Form.Item>

          <Form.Item label="Código do Banco">
            <InputBankStateful />
          </Form.Item>

          <Row gutter={20}>
            <Col span={6}>
              <Form.Item label="Agência">
                <InputAgencyStateful />
              </Form.Item>
            </Col>

            <Col span={13}>
              <Form.Item label="Número da Conta">
                <InputAccountNumberStateful />
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item label="Dígito">
                <InputAccountDigitStateful />
              </Form.Item>
            </Col>
          </Row>

          <Space align="end" direction="vertical" style={{ width: "100%" }}>
            <Button
              onClick={submit}
              disabled={isSaveButtonDisabled}
              type="primary"
              loading={isLoading}>
              Salvar
            </Button>
          </Space>
        </FormContent>
      </Form>
    </Card>
  )
}
